import TableReport from "../../../common/table/table.js";
import DailiesTable from "./dailiesTable.js";
import MessageEmptyData from "../../../common/messageEmptyData.js";

/**
 * Body report component for Dailies Search
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const DailiesSearchBody = (prop) => {
    const {filters, tableData, tableDataDisciplineId} = prop;

    if (!filters.isSubmitted) {
        return null;
    }

    if (tableData.length === 0) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <TableReport
                columns={
                    DailiesTable(tableDataDisciplineId)
                }
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'daily_search_results'}
                withGlobalSearch={true}
                scrollable={true}
            />
        </div>
    );
}

export default DailiesSearchBody;
